import { create } from 'zustand'
import { preciseAdd, preciseMinus } from '../../../util/formatUtil'

interface IPlayerStore {
  balance: number
  playerId: string
  playerName: string
  currency: string
  language: string
  authToken?: string
  masterFpId: number
  fpId: number
  lastSettledBalance: number
  sessionWinLose: number

  updateBalanceToSettledAmount: () => void
  updateSessionWinLose: (stake: number, payout: number) => void
}

export const usePlayerStore = create<IPlayerStore>((set, get) => ({
  balance: 0,
  playerId: '',
  playerName: '',
  currency: '',
  language: '',
  authToken: '',
  masterFpId: 1,
  fpId: 0,
  lastSettledBalance: -1,
  sessionWinLose: 0,

  updateBalanceToSettledAmount: () => {
    set({ balance: get().lastSettledBalance === -1 ? get().balance : get().lastSettledBalance })
  },
  updateSessionWinLose: (stake: number, payout: number) => {
    set({ sessionWinLose: preciseAdd(preciseMinus(get().sessionWinLose, stake), payout) })
  },
}))
